import pathToRegexp from 'path-to-regexp';

// see https://alltrails.atlassian.net/wiki/spaces/AH/pages/814776368/AllTrails+Pages+Page+Types#Explore-Pages
function getPageTitle(pathname) {
  if (pathToRegexp('/:locale?/explore').test(pathname)) {
    return 'explore search';
  }

  if (pathToRegexp('/:locale?/explore/map/:map').test(pathname)) {
    return 'explore map';
  }

  if (pathToRegexp('/:locale?/explore/recording/:recording').test(pathname)) {
    return 'explore recording';
  }

  if (pathToRegexp('/:locale?/explore/trail/*').test(pathname)) {
    return 'explore trail';
  }

  if (pathToRegexp('/:locale?/explore/map/new').test(pathname)) {
    return 'create map';
  }

  return 'unknown';
}

export { getPageTitle };
